import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c85eac34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "myQuestionsView" }
const _hoisted_2 = { class: "stat-cell" }
const _hoisted_3 = { class: "stat-text" }

import { onMounted, ref } from "vue";
import { Question, QuestionControllerService } from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";
import { IconPlus } from "@arco-design/web-vue/es/icon";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyQuestionsView',
  setup(__props) {

const router = useRouter();

const dataList = ref<Question[]>([]);
const total = ref(0);
const searchParams = ref({
  pageSize: 10,
  current: 1,
});

const loadData = async () => {
  const res = await QuestionControllerService.listMyQuestionVoByPageUsingPost(
    searchParams.value
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

onMounted(() => {
  loadData();
});

const columns = [
  { title: "ID", dataIndex: "id", width: 65 },
  { title: "标题", slotName: "title", ellipsis: true },
  { title: "标签", slotName: "tags", width: 200 },
  { title: "通过率", slotName: "acceptedRate", width: 150 },
  { title: "创建时间", slotName: "createTime", width: 120 },
  { title: "操作", slotName: "optional", width: 170 },
];

const onPageChange = (page: number) => {
  searchParams.value.current = page;
  loadData();
};

const toQuestionPage = (question: Question) => {
  router.push({ path: `/view/question/${question.id}` });
};

const doDelete = async (question: Question) => {
  const res = await QuestionControllerService.deleteQuestionUsingPost({
    id: question.id,
  });
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "我的题目",
      bordered: false
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/add/question')))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(IconPlus))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 创建题目 ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: columns,
          data: dataList.value,
          pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
        },
          onPageChange: onPageChange,
          "row-key": "id"
        }, {
          title: _withCtx(({ record }) => [
            _createVNode(_component_a_link, {
              onClick: ($event: any) => (_unref(router).push(`/view/question/${record.id}`))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.title), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          tags: _withCtx(({ record }) => [
            _createVNode(_component_a_space, { wrap: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    key: index,
                    color: "cyan",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          acceptedRate: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_progress, {
                percent: 
                record.submitNum ? record.acceptedNum / record.submitNum : 0
              ,
                "show-text": false,
                size: "small",
                style: {"width":"60px","display":"inline-block","vertical-align":"middle"}
              }, null, 8, ["percent"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(record.acceptedNum || 0) + "/" + _toDisplayString(record.submitNum || 0), 1)
            ])
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
          ]),
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (toQuestionPage(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 做题 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (
                _unref(router).push({
                  path: '/update/question',
                  query: { id: record.id },
                })
              )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_popconfirm, {
                  content: "确定删除该题目吗？",
                  onOk: ($event: any) => (doDelete(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "small",
                      type: "text",
                      status: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onOk"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination"])
      ]),
      _: 1
    })
  ]))
}
}

})